import { useCallback } from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Hint } from '@factorialco/deprecated-design-system'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'
import useLocalStorage from 'modules/core/lib/useLocalStorage'

import cycleStatusesLaunch from './assets/cycle-statuses-launch.jpg'

type CycleStatusLaunchModalProps = {
  canEditCompensationConcepts: boolean
  isPayrollRunTimelineFeatureEnabled: boolean
}

const CycleStatusLaunchModal = ({
  canEditCompensationConcepts,
  isPayrollRunTimelineFeatureEnabled,
}: CycleStatusLaunchModalProps) => {
  const storageKey = LOCAL_STORAGE_KEYS.compensationsCycleStatusLaunchModalShown
  const [isDismissed, setIsDismissed] = useLocalStorage<boolean>(storageKey, false)

  const handleDismiss = useCallback(() => {
    setIsDismissed(true)
  }, [setIsDismissed])

  const handleGoToHelpCenter = useCallback(() => {
    handleDismiss()
    window.open(helpCenterUrl('compensations_cycle_statuses'), '_blank', 'noopener,noreferrer')
  }, [handleDismiss])

  const showModal =
    canEditCompensationConcepts && isPayrollRunTimelineFeatureEnabled && !isDismissed

  if (!showModal) {
    return null
  }

  return (
    <Hint.NewModal onClose={handleDismiss} onFinish={handleDismiss}>
      <Hint.NewModal.ImageStep
        src={cycleStatusesLaunch}
        title={i18n.t('compensations.cycleStatusLaunchModal.title')}
        description={i18n.t('compensations.cycleStatusLaunchModal.description')}
      >
        <Box alignItems="center" justifyContent="center">
          <Button onClick={handleGoToHelpCenter}>
            {i18n.t('compensations.cycleStatusLaunchModal.go_to_help_center')}
          </Button>
        </Box>
      </Hint.NewModal.ImageStep>
    </Hint.NewModal>
  )
}

export default CycleStatusLaunchModal
